import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import ExportOverviewList from './ExportOverviewList'
import ExportOverviewPanel from './ExportOverviewPanel'
import { Tab, Tabs } from '@mui/material'
import useTitle from 'utils/customHook/useTitle'

const PiezoExportOverviewApp = () => {
    const [selectedTab, setSelectedTab] = useState('OVERVIEW')

    useTitle(() => [{
        title: i18n.piezometry,
        href: 'piezometry',
    }, {
        title: i18n.exportOverview,
        href: 'piezometry/exportOverview',
    }], [])

    const getPanel = () => selectedTab === 'OVERVIEW' ? <ExportOverviewPanel /> : <ExportOverviewList />

    return (
        <>
            <Tabs
                value={selectedTab}
                onChange={(e, newValue) => setSelectedTab(newValue)}
                variant='fullWidth'
                sx={{ marginTop: 1 }}
            >
                <Tab value={'OVERVIEW'} label={i18n.overview}/>
                <Tab value={'LIST'} label={i18n.table}/>
            </Tabs>
            {getPanel()}
        </>
    )
}

PiezoExportOverviewApp.propTypes = {
}

export default PiezoExportOverviewApp
